import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import FormikCheckbox from '../../../ui/FormikCheckbox';
class RequestAStayComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { secondaryAction, primaryAction } = this.props;
    return (<Formik
      initialValues={{ terms: [] }}
      onSubmit={primaryAction}
    >
      {({ values }) => (<Form>
        <div className="row p-2">
          <div className="col-12 mb-3 semi-bold">
            <FormikCheckbox
              name="terms"
              label="I understand and accept the potential charges to my credit card"
              value="accepted" />
          </div>
          <div className="col-12">
            <div className="row button-row">
              <div className="col">
                <label onClick={secondaryAction}>Back</label>
              </div>
              <div className="col text-right">
                <button type="submit" className="btn btn-primary" disabled={values.terms.indexOf('accepted') > -1 ? false : true}>Request a Stay</button>
              </div>
            </div>
          </div>
        </div>
      </Form>)}
    </Formik>)
  }
}

export default RequestAStayComponent;
